<si-application-header>
  <si-header-brand>
    <a si-header-siemens-logo routerLink="/main/chat-enhanced" aria-label="Siemens" class="d-none d-md-flex"></a>
  </si-header-brand>
  <si-header-actions>
    <si-header-collapsible-actions>
      <div class="d-none d-md-flex" id="appName" aria-label="PSS@E AI Assissant">Gridscale X™ PSS®E Copilot</div>
    </si-header-collapsible-actions>
    <si-header-collapsible-actions>
      <button
        type="button"
        icon="element-help"
        si-header-action-item
        [name]="'NAV.HELP' | translate"
        [siHeaderDropdownTriggerFor]="help"
      >
        {{ 'NAV.HELP' | translate }}
      </button>
    </si-header-collapsible-actions>
    <button
      si-header-account-item
      type="button"
      [name]="getUserName()"
      [siHeaderDropdownTriggerFor]="account"
    >
      {{ 'NAV.ACCOUNT' | translate }}
    </button>
  </si-header-actions>
</si-application-header>

<ng-template #account>
  <si-header-dropdown>
    <div class="mx-5">
      <div class="fw-bold">{{ getUserName() }}</div>
      <div>{{ getUserEmail() }}</div>
      <div class="d-flex align-items-center text-secondary mt-2">
      </div>
    </div>
    <div class="dropdown-divider"></div>
    <button *ngIf="showLanguage"
      si-header-dropdown-item
      icon="element-language"
      type="button"
      [siHeaderDropdownTriggerFor]="language"
    >
     {{ 'NAV.LANGUAGE' | translate }}
    </button>
    <button *ngIf="showTheme"
      si-header-dropdown-item
      icon="element-palette"
      type="button"
      [siHeaderDropdownTriggerFor]="theme"
    >
      {{ 'NAV.THEME' | translate }}
    </button>
    <button *ngIf="showProfile" si-header-dropdown-item icon="element-user" type="button">{{ 'NAV.PROFILE' | translate }}</button>
    <div *ngIf="showProfile" class="dropdown-divider"></div>
    <button si-header-dropdown-item icon="element-logout" type="button" (click)="logout()">{{ 'NAV.LOGOUT' | translate }}</button>
  </si-header-dropdown>
</ng-template>

<ng-template #help>
  <si-header-dropdown>
    <a si-header-dropdown-item routerLink="/main/about">
      {{ 'NAV.ABOUT' | translate }}
    </a>
  </si-header-dropdown>
</ng-template>

<ng-template #language>
  <si-header-dropdown>
    @for (language of languageItems; track language) {
    <button
      si-header-dropdown-item
      type="button"
      [checked]="getLanguage() === language.value ? 'check' : ''"
      (click)="switchLanguage(language.value)"
    >
      {{ language.label | translate }}
    </button>
    }
  </si-header-dropdown>
</ng-template>

<ng-template #theme>
  <si-header-dropdown>
      <button
        si-header-dropdown-item
        type="button"
        [checked]="getTheme() === 'auto' ? 'check' : ''"
        (click)="switchTheme('auto')"
      >
        {{ 'THEME.AUTO' | translate }}
      </button>
      <button
        si-header-dropdown-item
        type="button"
        [checked]="getTheme() === 'light' ? 'check' : ''"
        (click)="switchTheme('light')"
      >
        {{ 'THEME.LIGHT' | translate }}
      </button>
      <button
        si-header-dropdown-item
        type="button"
        [checked]="getTheme() === 'dark' ? 'check' : ''"
        (click)="switchTheme('dark')"
      >
        {{ 'THEME.DARK' | translate }}
      </button>
  </si-header-dropdown>
</ng-template>


<si-navbar-vertical
  navbarCollapseButtonText="collapse"
  navbarExpandButtonText="expand"
  [items]="menuItems"
  [collapsed]="true">
  <div class="si-layout-main-padding si-layout-inner" style="height: 100%;">
    <router-outlet />
  </div>
</si-navbar-vertical>
